module.exports = __webpack_public_path__ + "static/media/letemps.e1b0addf.png";